var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "custom-ddl" },
    [
      _vm.label
        ? _c(
            "label",
            { staticClass: "data-name", class: { regular: _vm.regularLabel } },
            [_vm._v(" " + _vm._s(_vm.label) + " ")]
          )
        : _vm._e(),
      _c(
        "div",
        [
          _c(
            "v-select",
            {
              key: _vm.objectkey,
              staticClass: "custom-v-select",
              class: {
                "was-Invalidated": _vm.error,
                "bold-placeholder": _vm.boldPlaceholder
              },
              attrs: {
                id: _vm.id,
                "append-to-body": _vm.placementTop,
                "calculate-position": _vm.placementTop
                  ? _vm.withPopper
                  : () => {},
                clearable: _vm.clearable,
                disabled:
                  _vm.isDisabled ||
                  (_vm.value != null && _vm.value["disabled"] != undefined
                    ? _vm.value["disabled"]
                    : false),
                label: _vm.fieldname,
                options: _vm.options,
                placeholder: _vm.placeholder,
                reduce: _vm.reduce,
                value: _vm.value
                  ? _vm.prefixText + _vm.value[_vm.fieldname]
                  : _vm.prefixText
              },
              on: { input: _vm.updateValue },
              scopedSlots: _vm._u(
                [
                  _vm.isHtml
                    ? {
                        key: "selected-option",
                        fn: function(option) {
                          return [
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(option[_vm.fieldname])
                              }
                            })
                          ]
                        }
                      }
                    : null,
                  {
                    key: "option",
                    fn: function(option) {
                      return [
                        _vm._t(
                          "option",
                          function() {
                            return [
                              _vm.isHtml
                                ? _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(option[_vm.fieldname])
                                    }
                                  })
                                : _c("span", [
                                    _vm._v(_vm._s(option[_vm.fieldname]))
                                  ])
                            ]
                          },
                          null,
                          option
                        )
                      ]
                    }
                  }
                ],
                null,
                true
              )
            },
            [
              [
                _c("input", {
                  staticClass: "vs__search",
                  attrs: { required: _vm.required },
                  domProps: { value: _vm.value },
                  on: {
                    input: function($event) {
                      return _vm.$emit("input", $event.target.value)
                    }
                  }
                })
              ]
            ],
            2
          )
        ],
        1
      ),
      _vm.error
        ? _c("error", {
            attrs: { message: _vm.customErrorMsg, variant: "no-border" }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }